module.exports = __webpack_public_path__ + "images/company/rank_medal/assessment_achievement_count_rank/4_ead60ed36fb43316dcfa0c9baeae23c4.png";